/**
 * JQuery
 */
import 'script!uglify!jquery';
// migrate (min is muted version)
import 'script!./../node_modules/jquery-migrate/dist/jquery-migrate.min';
// ui
import 'script!./../bower_components/jquery-ui/jquery-ui.min';
import './../bower_components/jquery-ui/themes/base/jquery-ui.css';
// table sorter
import 'script!uglify!tablesorter';
// drag table
import 'script!uglify!./../bower_components/dragtable/jquery.dragtable';
// checkboxes
import 'script!uglify!./../client-side/Checkboxes/jquery.checkboxes';
// chosen
import 'script!uglify!./../client-side/Chosen/chosen.jquery';
import './../client-side/Chosen/bootstrap-chosen.css';
// table head fixer
import 'script!uglify!./../client-side/TableHeadFixer/TableHeadFixer';

/**
 * Moment.js
 */
import 'script!uglify!./../node_modules/moment/min/moment-with-locales.min';

/**
 * Bootstrap
 */
import 'script!uglify!./../node_modules/bootstrap/dist/js/bootstrap';
// file input
import 'script!uglify!./../node_modules/bootstrap-fileinput/js/fileinput';
import 'script!uglify!./../node_modules/bootstrap-fileinput/js/locales/cs';
import 'script!uglify!./../node_modules/bootstrap-fileinput/js/locales/sk';
import './../node_modules/bootstrap-fileinput/css/fileinput.css';
// eonasdan bootstrap datetimepicker
import 'script!uglify!eonasdan-bootstrap-datetimepicker';
import './../node_modules/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';
// daterangepicker
import 'script!uglify!bootstrap-daterangepicker';
import './../node_modules/bootstrap-daterangepicker/daterangepicker.css';
// bootstrap-select
import 'script!uglify!bootstrap-select';
import './../node_modules/bootstrap-select/less/bootstrap-select.less';
// ajax-bootstrap-select
import 'script!uglify!ajax-bootstrap-select';
import './../node_modules/ajax-bootstrap-select/src/less/styles.less';

/**
 * Nette
 */
import 'script!uglify!./../bower_components/nette-forms/src/assets/netteForms';
import 'script!uglify!./../bower_components/nette.ajax.js/nette.ajax';

/**
 * Tree
 */
import 'script!uglify!./../client-side/Tree/js/tree_javascript';
import './../client-side/Tree/css/tree_css.css';

/**
 * FFS
 */
import FSRibbon from './Ribbon/js/ribbon';
import FSForms from './Form/js/fsForms';
import FSGridSnippet from './GridSnippet/js/grid';

/**
 * LESS
 */
import './../client-side/common/less/main.less';
import './../client-side/common/less/responsive.less';

import 'script!uglify!./../client-side/common/js/responsive';

/**
 * Form live validation
 */
import 'script!uglify!./../client-side/Form/js/formValidation';

/**
 * Metadata Logic
 */
import MetadataLogicConfigurator from './MetadataLogic/MetadataLogicConfigurator';

$(function()
{
  // initialization components
  $.nette.init();
  FSForms.init();
  FSGridSnippet.initAll();
  FSRibbon.init();
  MetadataLogicConfigurator.createDocumentControlsInit();
  MetadataLogicConfigurator.singleEditDocumentControlsInit();
  MetadataLogicConfigurator.bulkEditDocumentsControlsInit();

  // check fot duplicite init
  if (window.FSForms){
      console.log('%c FormFlow ERROR! Duplicite loading of JS, probably by AJAX!', 'background: red; color: white');
  }

  // check jquery version
  if (jQuery.fn.jquery != "3.3.1"){
      console.log('%c jQuery ERROR! FormFlow needs jQuery v3.3.1!', 'background: red; color: white');
  }

  // fs csrf ajax protection
  XMLHttpRequest.prototype.origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open   = function () {
    this.origOpen.apply(this, arguments);
    this.setRequestHeader('x-fs-token', $('#fs_token').val());
    this.addEventListener('load', function(event){
      if (this.responseText && this.responseText.substring(0,1) == '{' && this.responseText.indexOf('invalidCsrf') !== -1){
        var result = jQuery.parseJSON(this.responseText);
        if (result.reason == 'invalidCsrf' && result.message){
          event.stopImmediatePropagation();
          event.preventDefault();
          waiter_close();
          alert(result.message);
        }
      }
    });
  };

  // set global properties
  window.FSForms = FSForms;
  window.FSGridSnippet = FSGridSnippet;
  window.TracyMaxAjaxRows = 2;

  $(document).ajaxComplete(() => {
    setTimeout(function(){
      MetadataLogicConfigurator.createDocumentControlsInit();
      MetadataLogicConfigurator.singleEditDocumentControlsInit();
      MetadataLogicConfigurator.bulkEditDocumentsControlsInit();
    }, 10);
  });
});




// WEBPACK FOOTER //
// ./client-side/bootstrap.js